var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgQrPromptConfirmed = function SvgQrPromptConfirmed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 186,
    viewBox: "0 0 186 186",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156 2H163.5C174.546 2 183.5 10.9543 183.5 22V29.5",
    stroke: "#85E0A9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 183.5L22 183.5C10.9543 183.5 2 174.546 2 163.5L2 156",
    stroke: "#85E0A9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 29.5L2 22C2 10.9543 10.9543 2 22 2L29.5 2",
    stroke: "#85E0A9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4551 106.868L87.0872 108.327C87.4856 108.701 88.0196 108.895 88.565 108.865C89.1104 108.835 89.6198 108.583 89.9748 108.168L88.4551 106.868ZM122.369 70.3001C123.087 69.4608 122.989 68.1982 122.15 67.4802C121.31 66.7622 120.048 66.8605 119.33 67.6999L122.369 70.3001ZM67.3679 84.3566C66.5621 83.6011 65.2964 83.6419 64.541 84.4478C63.7855 85.2536 63.8263 86.5192 64.6321 87.2747L67.3679 84.3566ZM89.9748 108.168L122.369 70.3001L119.33 67.6999L86.9353 105.568L89.9748 108.168ZM64.6321 87.2747L87.0872 108.327L89.823 105.409L67.3679 84.3566L64.6321 87.2747Z",
    fill: "#85E0A9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M183.5 156L183.5 163.5C183.5 174.546 174.546 183.5 163.5 183.5L156 183.5",
    stroke: "#85E0A9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQrPromptConfirmed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/qr-prompt-confirmed.99a89c21.svg";
export { ForwardRef as ReactComponent };